import cloneDeep from 'lodash/cloneDeep'

export default {
  setConstants: (state, payload) => {
    state.constants = payload
  },
  setCostings: (state, payload) => {
    state.costings = payload
  },
  setCalculated: (state, payload) => {
    state.calculated = payload
  },
  setCalculatedDetailed: (state, payload) => {
    state.calculated.detailed = payload
  },
  setMain: (state, payload) => {
    state.calculated.main = payload
  },
  setSpecification: (state, payload) => {
    state.calculated.main.specification = payload
  },
  setMainSummary: (state, payload) => {
    state.calculated.main.summary = payload
  },
  setMainTotal: (state, payload) => {
    state.calculated.main.total = payload
  },
  setTotals: (state, payload) => {
    state.totals = payload
  },
  setMainEquipment: (state, payload) => {
    state.calculated.main.equipment = payload
  },
  setMainVanRate: (state, payload) => {
    state.calculated.main.van = payload
  },
  updateTotals: (state, payload) => {
    const index = state.totals.findIndex(item => item.ref === payload.ref)
    state.totals[index] = payload
  },
  updateDetailed: (state, payload) => {
    state.calculated.detailed[payload.ref] = payload.collection
  },
  updateMainSummary: (state, payload) => {
    const index = state.calculated.main.summary.findIndex(item => item.key === payload.key)
    state.calculated.main.summary[index] = payload
    state.calculated.main.summary = cloneDeep(state.calculated.main.summary)
  },
  resetAll: state => {
    state.constants = []
    state.costings = []
    state.calculated = {
      main: {
        summary: [],
        shift: [],
        van: [],
        total: [],
        equipment: [],
      },
      detailed: {
        labour: [],
        expenses: [],
        processing: [],
        additional: [],
      },
    }
    state.totals = []
  },
}
